export enum ReloadMode {
  SOFT = 'soft',
  HARD = 'hard',
}
